import request from '@/utils/request'

let SweepstakesApi = {
  /*抽奖列表*/
  sweepstakesList(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/index', data, errorback);
  },
  /*添加抽奖资料*/
  getAddSweepstakes(data, errorback) {
    return request._get('/shop/plus.sweepstakes.sweepstakes/add', data, errorback);
  },
  /*添加抽奖*/
  addSweepstakes(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/add', data, errorback);
  },
  /*获取抽奖数据*/
  editSweepstakes(data, errorback) {
    return request._get('/shop/plus.sweepstakes.sweepstakes/edit', data, errorback);
  },
  /*保存抽奖*/
  saveSweepstakes(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/edit', data, errorback);
  },
  /*删除抽奖*/
  delSweepstakes(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes/delete', data, errorback);
  },
  /*抽奖抽奖记录列表*/
  sweepstakesRecordList(data, errorback) {
    return request._post('/shop/plus.sweepstakes.record/index', data, errorback);
  },
  /*抽奖奖项列表*/
  sweepstakesAwardsList(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes_awards/index', data, errorback);
  },
  /*添加抽奖奖项资料*/
  getAddSweepstakesAwards(data, errorback) {
    return request._get('/shop/plus.sweepstakes.sweepstakes_awards/add', data, errorback);
  },
  /*添加抽奖奖项*/
  addSweepstakesAwards(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes_awards/add', data, errorback);
  },
  /*获取抽奖奖项数据*/
  editSweepstakesAwards(data, errorback) {
    return request._get('/shop/plus.sweepstakes.sweepstakes_awards/edit', data, errorback);
  },
  /*保存抽奖奖项*/
  saveSweepstakesAwards(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes_awards/edit', data, errorback);
  },
  /*删除抽奖奖项*/
  delSweepstakesAwards(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes_awards/delete', data, errorback);
  },

  /*批量生码*/
  addCode(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes_awards/add_code', data, errorback);
  },
  /*码详情*/
  codeList(data, errorback) {
    return request._post('/shop/plus.sweepstakes.sweepstakes_awards/code_list', data, errorback);
  },

  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.sweepstakes.setting/index', data, errorback);
  },

  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.sweepstakes.setting/index', data, errorback);
  },
}
export default SweepstakesApi;



// WEBPACK FOOTER //
// ./src/api/sweepstakes.js